import React, { useState } from "react";
import { Link } from "react-router-dom";
import "../styles/Navbar.scss";
import logo from "../assets/logo2.png";


// Minimal lock icon as a React component
const LockIcon: React.FC<{ size?: number; className?: string }> = ({ size = 16, className }) => (
  <svg
    width={size}
    height={size}
    viewBox="0 0 24 24"
    fill="none"
    stroke="currentColor"
    strokeWidth="2"
    strokeLinecap="round"
    strokeLinejoin="round"
    className={className}
    aria-hidden="true"
  >
    <rect x="3" y="11" width="18" height="10" rx="2" ry="2" />
    <path d="M7 11V7a5 5 0 0 1 10 0v4" />
  </svg>
);

const Navbar = () => {
  const [isOpen, setIsOpen] = useState(false);

  return (
    <nav className="navbar">
      <div className="logo">
        <img src={logo} alt="Model Portfolio" />
      </div>

      {/* Toggle Button */}
      <div
        className={`menu-icon ${isOpen ? "open" : ""}`}
        onClick={() => setIsOpen(!isOpen)}
      >
        <span></span>
        <span></span>
        <span></span>
      </div>

      {/* Menu Overlay */}
      <div className={`menu-overlay ${isOpen ? "open" : ""}`}>
        <div className="menu-logo">
          <img src={logo} alt="Menu Logo" />
        </div>
        <ul className="nav-links">
          <li style={{ "--i": 1 } as React.CSSProperties}>
            <Link to="/" onClick={() => setIsOpen(false)}>Home</Link>
          </li>
          <li style={{ "--i": 2 } as React.CSSProperties}>
            <Link to="/models" onClick={() => setIsOpen(false)}>Models</Link>
          </li>
          {/* <li style={{ "--i": 3 } as React.CSSProperties}>
            <Link to="/projects" onClick={() => setIsOpen(false)}>Projects</Link>        // add it later when doneupdating project page
          </li> */}

       <li
            style={{ "--i": 3 } as React.CSSProperties}
            className="disabled-link"
            title="Coming soon"
          >
            <span className="locked">
              Projects <LockIcon className="lock-icon" />
            </span>
          </li>

          <li style={{ "--i": 4 } as React.CSSProperties}>
            <Link to="/contact" onClick={() => setIsOpen(false)}>Contact</Link>
          </li>
        </ul>
      </div>
    </nav>
  );
};

export default Navbar;
